import React, { useRef, useEffect, useState, useContext } from 'react';
import { getSmoothStepPath, EdgeLabelRenderer } from 'reactflow';
import { invertColor } from '../../HR/TimeClock/Util';
import AppContext from '../../../Context/AppContext';
import { OnClickEdge } from '../../../Context/AppActions';
// import { FlowContext } from '../Flow';
import { source } from 'react-dom-factories';
import { useSelector } from "react-redux"; 

const CustomEdge = (params) => {
  const {
    id,
    sourceX,
    source,
    target,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    style = {},
    markerEnd,
    data,
    label,
  } = params;
  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });
  const AppData = useContext(AppContext);
  // const FlowContext = useContext(FlowContext);
  const { dispatch ,state } = AppData || {};
  const pathRef = useRef(null);
  const [labelPos, setLabelPos] = useState({ x: 0, y: 0 });

  const [color,setColor] = useState();
  const EnableFlow = useSelector((state) => state.AppReduxContext.EnableFlow);
  useEffect(() => {
    if (pathRef.current) {
      const pathLength = pathRef.current.getTotalLength(); // Total length of the path
      const position = pathRef.current.getPointAtLength(pathLength * 0.5); // 30% of the path length

      setLabelPos({ x: position.x, y: position.y });
    }
  }, [sourceX, sourceY, targetX, targetY, edgePath]);
  useEffect(e=>{
    if (id) {
      let prevNode = state.FlowEdgeAndNodes?.nodes?.find(res => res.id == source);
      let prevEd = state.FlowEdgeAndNodes?.edges?.find(k => k.target == prevNode?.id);
      if(prevNode?.type == "diverse"){
        while (prevNode?.type != "custom" && prevEd) {
          prevEd = state.FlowEdgeAndNodes?.edges?.find(k => k.target == prevNode?.id);
          if (prevEd && prevEd.source){
            prevNode = state.FlowEdgeAndNodes?.nodes?.find(res => res.id == prevEd?.source);
          }
        }
        setColor(prevEd?.data?.color)
      }
    }
  },[state.FlowEdgeAndNodes,id])
  const handleLabelClick = (event) => {
    dispatch(OnClickEdge(params));
  };

  return (
    <>
      {/* Step-like edge path */}
      <path
        ref={pathRef} // Attach the ref to access the path for calculations
        id={id}
        className="react-flow__edge-path"
        d={edgePath}
        style={{
          ...style,
          stroke: data?.disable? "rgb(118 118 118)" : color?color : data?.color ? data?.color : "rgb(144 144 144)",
          // opacity: data.disable ? "0.3":"1",
          strokeWidth: 2,
          strokeDasharray: 5, // Dotted pattern for the path
          animation: `${EnableFlow && !data?.disable ?"dash-animation":"test"} 3s linear infinite`,
        }}
        markerEnd={markerEnd}
      />

      {label && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%)`,
              left: labelPos.x,
              top: labelPos.y,
              width: "max-content",
              // opacity: data.disable ? "0.3":"1",
              cursor:"pointer",
              padding: '2px 4px',
              borderRadius: '3px',
              fontSize: 12,
              pointerEvents: 'all',
              boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.16)',
              backgroundColor: data?.disable? "rgb(236 236 236)" :data?.color ? data?.color : "#fff5e0",
              color:  data?.disable? "rgb(118 118 118)" : data?.color ? invertColor(data?.color, true) : "black",
            }}
            className="nopan"
            onClick={handleLabelClick}
          >
            {label}
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
};

export default CustomEdge;